import React from 'react';

const LOGOS = [
  { src: '/logos/csmvs.png', alt: 'CSMVS Museum' },
  { src: '/logos/knma.png', alt: 'Kiran Nadar Museum of Art' },
  { src: '/logos/map-museum.png', alt: 'MAP Museum of Art & Photography' },
  { src: '/logos/ngma.png', alt: 'National Gallery of Modern Art' },
  { src: '/logos/logo6.png', alt: 'Ministry of Culture' },
  { src: '/logos/logo7.png', alt: 'Organisation' },
  { src: '/logos/logo8.png', alt: 'Organisation' },
  { src: '/logos/logo9.png', alt: 'Organisation' },
  { src: '/logos/logo10.png', alt: 'Organisation' },
];

const LogoBanner = () => {
  // Duplicate logos for seamless infinite scroll
  const allLogos = [...LOGOS, ...LOGOS, ...LOGOS];

  return (
    <div data-testid="logo-banner" className="overflow-hidden">
      <div className="text-center mb-8">
        <p className="text-xs uppercase tracking-[0.25em] font-bold" style={{ color: '#D4820A' }}>
          Discover open roles across India&rsquo;s cultural sector, compiled on CultureCareers
        </p>
      </div>
      <div className="relative">
        <div
          className="flex items-center gap-16 animate-scroll"
          style={{ width: 'max-content' }}
        >
          {allLogos.map((logo, i) => (
            <div
              key={i}
              className="flex-shrink-0 flex items-center justify-center"
              style={{ width: '160px', height: '80px' }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                decoding="async"
                width="160"
                height="80"
                className="max-h-full max-w-full object-contain"
                style={{ filter: 'grayscale(100%) brightness(1.8)', opacity: 0.6, transition: 'all 0.3s ease' }}
                onMouseEnter={(e) => { e.target.style.filter = 'grayscale(0%) brightness(1)'; e.target.style.opacity = '1'; }}
                onMouseLeave={(e) => { e.target.style.filter = 'grayscale(100%) brightness(1.8)'; e.target.style.opacity = '0.6'; }}
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-160px * ${LOGOS.length} - 64px * ${LOGOS.length})); }
        }
        .animate-scroll {
          animation: scroll 36s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default LogoBanner;
